import React from 'react'
import ConnetedNav from './Navbar'
import ConnetedFooter from './Footer'

const ContactUs = () => {
  return (
    <div className='connetec__bankContainer'>
        <ConnetedNav />
   <div className='container mx-auto'>
    
            <section className='py-20'>
                <div className='px-[124px]'>
                    <div className='flex justify-center'>
                        <span className='connected_banking_heading'>Contact Us</span>
                    </div>
                    <div className='py-16'>
                        <span className='aboutus_content text-center block'>Let’s make your business smarter and more efficient with Haoda Pay</span>
                    </div>
                </div>
            </section>
            <section className='py-20 px-[124px]'>
                  <div className='about_us_heading'>Connect with Our Experts:
                  </div>
                  <div className='py-16 about_detail_text'>Fill in the details below and we’ll reach out shortly to help you get started with ease</div>
                  <div className='grid justify-center '>
                      <div className='text-center pb-16 about_us_text'>Get in touch to discuss</div>

                      <div className='pb-5'>
                          <input type='text' placeholder='Name' className='contact_input outline-none' />
                      </div>
                      <div className='pb-5'>
                          <input type='text' placeholder='Phone Number' className='contact_input outline-none' />
                      </div>
                      <div className='pb-5'>
                          <input type='text' placeholder='Work Email' className='contact_input outline-none' />
                      </div>
                      <div className=''>
                          <textarea placeholder='Tell us more about your requirement' className='textarea_about' /> 
                      </div>

                      <div className='pt-7 flex justify-center'>
                        <button className='text-[25px] px-16 py-4'>
                         Submit
                      </button>
                      </div>
                  </div>
            </section>
    </div>
    <ConnetedFooter />
    </div>
  )
}

export default ContactUs